// @ts-check
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'
import './components/Container/container.css'

const container = document.getElementById('mdctopnav-root')
if (container) {
  const root = createRoot(container)
  root.render(<App />)
}
